import React, { useState,useEffect } from 'react';
import { Drawer } from 'antd';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour'; // ✅ Import StepFour
import './NewEmailSetup.css';

const NewEmailSetup = ({ visible, onClose, initialKeyworkdsData,screenLoading, startStep = 0}) => {
  const [currentStep, setCurrentStep] = useState(startStep);
  // Notification settings state
    const defaultNotificationSettings = {
    push: 1,
    email: 1,
    calendar: 0,
    reminderEnabled: 0,
  };
  const [notificationSettings, setNotificationSettings] = useState(defaultNotificationSettings);

  useEffect(() => {
      const details = initialKeyworkdsData?.data?.email_assistant_setup_details;
      if (details) {
        setNotificationSettings({
          push: details.push ?? 1,
          email: details.email ?? 1,
          calendar: details.is_calendar_sync_enabled ?? 0,
          reminderEnabled: details.reminder_offset ?? 0,
        });
      }
    }, [initialKeyworkdsData]);

  const [reminder, setReminder] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const goToNextStep = () => setCurrentStep((prev) => prev + 1);

  const handleSaveReminder = (reminderData) => {
    setReminder(reminderData);
    setModalVisible(false);
  };

  const saveNotification = () => {
    console.log("Saving:", notificationSettings, reminder);
    onClose(); // or trigger any actual saving logic
  };

  const skipAndClose = () => {
    console.log("Skipping and using defaults");
    onClose();
  };
  // email and notificationData
  // console.log("keywordskeywordskeywords",initialKeyworkdsData?.data?.email_assistant_setup_details?.childrens )
  // console.log("keywordskeywordskeywords",initialKeyworkdsData?.data?.email_assistant_setup_details )

  const steps = [
    {
      title: 'Connect Email',
      content: <StepOne onNext={goToNextStep} onSkip={onClose} />,
    },
    {
      title: 'Email Assistant',
      content: <StepTwo onStart={goToNextStep} onClose={onClose} />,
    },
    {
      title: 'Fine-Tune Assistant',
      content: <StepThree onNext={goToNextStep} onClose={onClose} initialChildrenData={initialKeyworkdsData?.data?.email_assistant_setup_details?.childrens} />,
    },
    {
      title: 'Stay Notified', // ✅ Step 4
      content: (
        <StepFour
          notificationSettings={notificationSettings}
          setNotificationSettings={setNotificationSettings}
          reminder={reminder}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          handleSaveReminder={handleSaveReminder}
          saveNotification={saveNotification}
          skipAndClose={skipAndClose}
          onNext={goToNextStep}
        />
      ),
    },
  ];

  return (
    <Drawer
      open={visible}
      loading={screenLoading}
      onClose={onClose}
      closable={false}
      title={null}
      width="83%"
      mask={false}
      maskClosable={false}
      footer={null}
    >
      <div className="emailSeupModal">{steps[currentStep].content}</div>
    </Drawer>
  );
};

export default NewEmailSetup;
